import { render } from "./RegisterContact.vue?vue&type=template&id=a7b10144&scoped=true"
import script from "./RegisterContact.vue?vue&type=script&lang=js"
export * from "./RegisterContact.vue?vue&type=script&lang=js"

import "./RegisterContact.vue?vue&type=style&index=0&id=a7b10144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b10144"]])

export default __exports__